"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _AuthModal = _interopRequireDefault(require("./AuthModal"));

var _componentRender = _interopRequireDefault(require("../_utils/component-render"));

var authModal = (0, _componentRender.default)(_AuthModal.default);

_AuthModal.default.open = function (data) {
  if (data === void 0) {
    data = {};
  }

  return authModal(data).run();
};

var _default = _AuthModal.default;
exports.default = _default;